import React from 'react'
import PropTypes from 'prop-types'

import styles from './Settings.module.scss'
import Navigations from 'features/navigations'

const SettingsLayout = ({ children }) => {
    const menuItems = [
        'Account',
        'Appearance',
        'Integrations',
        'Team',
        'Billing',
    ]
    const options = [
        {
            value: 'account',
            label: 'Account',
        },
        {
            value: 'appearance',
            label: 'Appearance',
        },
        {
            value: 'integrations',
            label: 'Integrations',
        },
        {
            value: 'team',
            label: 'Team',
        },
        {
            value: 'billing',
            label: 'Billing',
        },
    ]
    const accessPath = 'settings.nav'
    const routePath = 'settings'
    return (
        <>
            <Navigations.Component.Sub
                menuItems={menuItems}
                accessPath={accessPath}
                routePath={routePath}
            />
            <section className={styles.settingsLayout}>{children}</section>
        </>
    )
}

SettingsLayout.propTypes = {
    children: PropTypes.node,
}

export default SettingsLayout
